import { MouseEventHandler } from 'react';
import {
  Pressable as RNPressable,
  PressableProps as RNPressableProps,
} from 'react-native';

export type PressableProps = RNPressableProps & {
  onHoverIn?: MouseEventHandler;
  onHoverOut?: MouseEventHandler;
};

export function Pressable(props: PressableProps) {
  return <RNPressable {...props} />;
}
